import * as React from 'react';
import { formatDateStrWithTime, formatTimeStr } from 'utils';
import { Formik, Form, Field } from 'formik';
import { useListing } from 'hooks';

import { ClientContactTag } from '@bb/contacts';
import styles from './appointment_book.module.scss';

// TODO: Type me / Need Refactor
interface Step4MobileProps {
  isMobile: any;
  appointment: any;
  listing: any;
  currentStep: any;
  mobileWorkflowSteps: any;
  showCaptcha: any;
  isMls: any;
  selectedUser: any;
  coopUserOrg: any;
  bookFor: any;
  sameOrg: any;
  appointmentTypes: any;
  updateState: any;
  notifications: any;
  isTimeChange: boolean;
  isListingContact: boolean;
  originalAppointment: any;
  keepOriginalAppointment: boolean;
  hasMobileNumber: boolean;
  extAuth: any;
  showingOverrideType: boolean;
  // functions
  selectNotifyMethod: any;
  moveToStep: any;
  setHasMobileNumber: React.Dispatch<React.SetStateAction<boolean>>;
}

const Step4Mobile: React.FC<Step4MobileProps> = ({
  appointment,
  listing,
  appointmentTypes,
  bookFor,
  coopUserOrg,
  currentStep,
  isMls,
  isMobile,
  mobileWorkflowSteps,
  notifications,
  sameOrg,
  selectedUser,
  showCaptcha,
  isTimeChange,
  isListingContact,
  originalAppointment,
  keepOriginalAppointment,
  hasMobileNumber,
  extAuth,
  showingOverrideType,
  // functions
  updateState,
  selectNotifyMethod,
  moveToStep,
  setHasMobileNumber,
}) => {
  const [showNote, setShowNote] = React.useState(false);

  const [isAppointmentTypesFocused, setIsAppointmentTypesFocused] =
    React.useState(false);
  const [timeChangeModal, setTimeChangeModal] = React.useState(
    isTimeChange && isListingContact,
  );

  React.useEffect(() => {
    if (
      currentStep === 3 &&
      !timeChangeModal &&
      isTimeChange &&
      isListingContact
    ) {
      setTimeChangeModal(true);
    }
  }, [currentStep]);

  const handleOptionChange = (
    changeEvent: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const newValue = changeEvent.target.value;
    updateState((draft: any) => {
      draft.keepOriginalAppointment = newValue === 'keep';
    });
  };

  const validate = (values: any) => {
    if (isMls && !values.phone && !extAuth?.hasFeature('SHOWING_AGENT_SMS')) {
      setHasMobileNumber(false);
    } else {
      setHasMobileNumber(true);
    }
    updateState((draft: any) => {
      if (!draft.notifications) {
        draft.notifications = {};
      }
      draft.notifications.registeredOffers = values.registeredOffers;
      draft.appointment.type = values.appointmentType;
      draft.appointment.coop.phone = values.phone;
      draft.appointment.note = values.notes;
    });
  };

  /**
   * onSubmit is required prop on formik component.
   * Actual submit logic is handled by MobileButtons.tsx so an empty function is used here.
   */
  const emptyFunc: () => void = () => undefined;
  const showMobileField = React.useMemo(() => (
      (extAuth && !extAuth?.hasFeature('SHOWING_AGENT_SMS')) ||
      (appointment?.coop?.orgFeatures &&
        !appointment?.coop?.orgFeatures?.includes('SHOWING_AGENT_SMS'))
    ), [extAuth, appointment]);

  const showSMSField = React.useMemo(() => (
      (extAuth?.hasFeature('SHOWING_AGENT_SMS') ||
        appointment?.coop?.orgFeatures?.includes('SHOWING_AGENT_SMS')) &&
      appointment?.coop?.text
    ), [extAuth, appointment]);

  // Sellers, tentants and landlords/managers can't add notes
  const showAddNote = !extAuth?.user?.tags?.some((t: ClientContactTag) =>
    [
      ClientContactTag.Seller,
      ClientContactTag.Landlord,
      ClientContactTag.Tenant,
    ].includes(t),
  );

  return (
    <>
      {isMobile && currentStep === 3 && (
        <>
          <Formik
            initialValues={{
              appointmentType: appointment?.type || '',
              phone: appointment?.coop?.phone || '',
              note: '',
              // Should be booleans
              notifyEmail: !!appointment?.notify?.email,
              notifyOffice: !!appointment?.notify?.office,
              registeredOffers: !!notifications?.registeredOffers,
            }}
            validate={values => validate(values)}
            onSubmit={emptyFunc}
          >
            {({ isSubmitting, values }) => (
              <Form>
                <div
                  className={`form-group col-md-5 x-align ${
                    currentStep === mobileWorkflowSteps.confirmDetailsStep
                      ? styles.stepActive
                      : styles.stepInactive
                  }`}
                >
                  <hr
                    className={`${styles.titleDivider} ${styles.titleDividerTop}`}
                  />
                  <h3 className={styles.titleBlock}>
                    <span className={styles.stepTitle}>
                      <span>
                        <strong
                          onClick={() => moveToStep(1)}
                          style={{ color: '#3498db' }}
                        >
                          Date
                        </strong>
                        /
                      </span>
                      <span>
                        <strong
                          onClick={() => moveToStep(2)}
                          style={{ color: '#3498db' }}
                        >
                          Time
                        </strong>
                        /
                      </span>
                      Confirm Details
                    </span>
                    {isListingContact && isTimeChange && (
                      <div className={styles.orignalTimeSubTitle}>
                        <strong>Original Request:</strong>{' '}
                        {formatDateStrWithTime(
                          originalAppointment.time,
                          listing.timezone,
                        )}
                        {' - '}
                        {formatTimeStr(
                          originalAppointment.timeEnd,
                          listing.timezone,
                        )}
                      </div>
                    )}
                  </h3>
                  <hr
                    className={`${styles.titleDivider} ${styles.titleDividerBottom}`}
                  />
                  <div
                    className={`col-md-12 ${styles.contentScrollableOnMobile}`}
                  >
                    {isListingContact && isTimeChange && (
                      <div className={styles.sellerTimeChangeStep4}>
                        New Suggested Showing:
                      </div>
                    )}
                    <table className="table" style={{ width: '100%' }}>
                      <tbody>
                        <tr>
                          <td className="table-key">Date:</td>
                          <td>{appointment?.date}</td>
                        </tr>
                        <tr>
                          <td className="table-key">Time:</td>
                          <td>
                            {appointment?.time !== true && (
                              <span>
                                {appointment?.time?.format('H:mm A')} -
                                {appointment?.timeEnd?.format('H:mm A')}
                              </span>
                            )}
                            {appointment?.time === true && (
                              <span className="text-danger">
                                Please pick a timeslot
                              </span>
                            )}
                          </td>
                        </tr>
                        {!(isListingContact && isTimeChange) && (
                          <tr>
                            <td className="table-key">
                              <strong>Type:</strong>
                              <span
                                className="pull-right"
                                onClick={() => {
                                  if (!showCaptcha && !showingOverrideType)
                                    setIsAppointmentTypesFocused(true);
                                }}
                              >
                                {!showingOverrideType && (
                                  <i className="fa fa-edit"></i>
                                )}
                              </span>
                            </td>
                            <td>
                              {isAppointmentTypesFocused ? (
                                <Field
                                  component="select"
                                  name="appointmentType"
                                  className={`form-control form-control-sm`}
                                  onBlur={() =>
                                    setIsAppointmentTypesFocused(false)
                                  }
                                  disabled={showCaptcha || showingOverrideType}
                                >
                                  {appointmentTypes.map((at: any) => (
                                    <option key={at} value={at}>
                                      {at}
                                    </option>
                                  ))}
                                </Field>
                              ) : (
                                <span>{appointment?.type}</span>
                              )}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {isListingContact && isTimeChange ? (
                      <>
                        <label>{appointment.coop.name}</label>
                        <div className="appointment-small">
                          {appointment.coop.org && (
                            <>
                              <div>{appointment.coop.org.name}</div>
                              <div>{appointment.coop.org.address}</div>
                            </>
                          )}
                        </div>
                      </>
                    ) : (
                      <>
                        {showMobileField && (
                          <div className="form-group">
                            <label>Mobile:</label>
                            <Field
                              type="text"
                              name="phone"
                              required={isMls}
                              value={appointment?.coop?.phone}
                              placeholder="Phone"
                              disabled={showCaptcha}
                              className="form-control"
                            />
                            {!hasMobileNumber && (
                              <label className="error">
                                <span className="error">Phone is required</span>
                              </label>
                            )}
                          </div>
                        )}
                        <div className="form-group">
                          <label>Send my confirmation to</label>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="row">
                                <div className="col-xs-2">
                                  <label className="control-label">
                                    <Field
                                      name="notifyEmail"
                                      render={({ field, form }: any) => (
                                          <input
                                            type="checkbox"
                                            checked={appointment?.notify?.email}
                                            onClick={() => {
                                              selectNotifyMethod('email');
                                            }}
                                            {...field}
                                          />
                                        )}
                                      data-cy="notify-by-email"
                                      disabled={extAuth && showCaptcha}
                                    />
                                  </label>
                                </div>
                                <div className="col-xs-10">
                                  <label>Email:</label>
                                  <span style={{ marginLeft: '5px' }}>
                                    {appointment?.coop?.email}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          {showSMSField && (
                            <div className="row">
                              <div className="col-md-12">
                                <div className="row">
                                  <div className="col-xs-2">
                                    <label className="control-label">
                                      <Field
                                        name="notifyText"
                                        render={({ field, form }: any) => (
                                            <input
                                              type="checkbox"
                                              checked={
                                                appointment?.notify?.text
                                              }
                                              onClick={() => {
                                                selectNotifyMethod('text');
                                              }}
                                              {...field}
                                            />
                                          )}
                                        data-cy="notify-by-text"
                                        disabled={extAuth && showCaptcha}
                                      />
                                    </label>
                                  </div>
                                  <div className="col-xs-10">
                                    <label>SMS:</label>
                                    <span style={{ marginLeft: '5px' }}>
                                      {appointment?.coop?.text || ''}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="row">
                            <div className="col-md-12">
                              <div className="row">
                                <div className="col-xs-2">
                                  <label className="control-label">
                                    <Field
                                      render={({ field, form }: any) => (
                                          <input
                                            type="checkbox"
                                            checked={
                                              appointment?.notify?.office
                                            }
                                            onClick={() =>
                                              selectNotifyMethod('office')
                                            }
                                            {...field}
                                          />
                                        )}
                                      name="notifyOffice"
                                      data-cy="notify-by-office"
                                      disabled={extAuth && showCaptcha}
                                    />
                                  </label>
                                </div>
                                <div className="col-xs-10">
                                  <label>Office:</label>
                                  <span style={{ marginLeft: '5px' }}>
                                    {coopUserOrg?.phone ||
                                      selectedUser?.org?.phone}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {showAddNote &&
                      (showNote ? (
                        <div className="form-group">
                          <label>Notes</label>
                          <Field
                            name="notes"
                            component="textarea"
                            className="form-control"
                            rows="6"
                            disabled={showCaptcha}
                            data-cy="input-note"
                          />
                        </div>
                      ) : (
                        <button
                          onClick={() => setShowNote(true)}
                          className="btn btn-default"
                          disabled={showCaptcha}
                          data-cy="add-note"
                          style={{ marginBottom: '10px' }}
                        >
                          Add Note
                        </button>
                      ))}

                    {isMls && !(isListingContact && isTimeChange) && (
                      <div>
                        <label
                          style={{ fontSize: '12px', textAlign: 'center' }}
                        >
                          <Field
                            name="registeredOffers"
                            render={({ field, form }: any) => (
                                <input
                                  type="checkbox"
                                  checked={
                                    notifications?.registeredOffers ||
                                    field.value
                                  }
                                  {...field}
                                />
                              )}
                            checked={notifications?.registeredOffers}
                            disabled={showCaptcha}
                          />
                          Notify me regarding registered offers
                        </label>
                      </div>
                    )}
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          {timeChangeModal && isTimeChange && isListingContact && (
            <>
              <div className={styles.mobileSellerTimeChangeOverlay}></div>
              <div className={styles.mobileSellerTimeChangeModal}>
                <div className={styles.modalClockIcon}>
                  <i className={`fa fa-clock-o ${styles.faClockIcon}`}></i>
                </div>
                <div className={styles.timeChangeModalHeader}>
                  One last thing!
                </div>
                <div className={styles.timeChangeModalBody}>
                  If the showing agent does not accept the new suggested time,
                  would you like to deny their original showing?
                </div>
                <div className={styles.timeChangeRadioContainer}>
                  <div className={styles.timeChangeRadioForm}>
                    <input
                      className={styles.timeChangeRadio}
                      type="radio"
                      value="cancel"
                      checked={!keepOriginalAppointment}
                      onChange={handleOptionChange}
                    />
                    <span className={styles.timeChangeRadioLabel}>Deny</span>
                  </div>
                  <div className={styles.timeChangeRadioForm}>
                    <input
                      className={styles.timeChangeRadio}
                      type="radio"
                      value="keep"
                      checked={keepOriginalAppointment}
                      onChange={handleOptionChange}
                    />
                    <span className={styles.timeChangeRadioLabel}>
                      Keep Original
                    </span>
                  </div>
                </div>
                <div
                  className={styles.timeChangeDone}
                  onClick={() => setTimeChangeModal(false)}
                >
                  Done
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default Step4Mobile;
